import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { UploadFile } from './components/UploadFile';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={UploadFile} />
        <Route path='/upload-file' component={UploadFile} />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js